module.exports = __webpack_public_path__ + "img/Group 1421 (2).404e4ba0.png";